<template>
  <div class="home-main">
    <Row class="code-row">
      <Col span="24">
      <!-- <simple></simple> -->
      <indexHome></indexHome>
      </Col>
    </Row>

  </div>
</template>

<script>
import simple from "./data/simple.vue"; // 工单数据
import enter from "./data/enter.vue"; // 快捷入口
import workSum from "./data/workSum.vue"; // 工单数量
import progressCenter from "./data/progressCenter.vue"; // 流程中心
import knowledge from "./data/knowledge.vue"; // 知识库
import news from "./data/news.vue"; // 消息提醒
import newWork from "./data/newWork.vue"; //快速报修
import indexHome from "./data/indexHome.vue";

export default {
  name: "home",
  components: {
    simple,
    enter,
    progressCenter,
    workSum,
    newWork,
    indexHome
  },
  data() {
    return {
      simple_info: {},
    };
  },
  computed: {
    userName() {
      return $utils.data.get("auth", "uname") || "";
    },
    shopName() {
      return $utils.data.get("auth", "shop_name") || "";
    },
    avatorPath() {
      return $utils.data.get("auth", "avatar");
    },
    last_login_time() {
      return $utils.data.get("auth", "last_login_time") || "";
    },
    isSystem() {
      return $utils.data.get("auth", "is_system") || false;
    },
    isAllOrder() {
      return $utils.data.get("auth", "is_all_order") || false;
    },
  },
  created() {
  },
  methods: {
    complete() {
      this.$refs.progressCenter.loadHomeData();
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../styles/common.less";

::v-deep .ivu-card {
  background: #f5f7fa !important;
}

// .code-row {
//   //height: 50%;
// }</style>
